var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"pt-3":"","pb-4":"","pl-2":""}},[_c('v-layout',{attrs:{"row":""}},[_c('AreaPolygonMap',{ref:"areaMap"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }